var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.link)?_c('li',[_c('base-link',{attrs:{"link":_vm.item.link.url,"target":_vm.item.link.target,"title":_vm.item.link.name}},[_vm._v("\n    "+_vm._s(_vm.item.link.name)+"\n  ")]),_vm._v(" "),(_vm.children)?_c('ul',_vm._l((_vm.children),function(child,i){return _c('navigation-tree-item',{key:i,attrs:{"item":child}})}),1):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }